import React from 'react';
import { Outlet } from 'react-router-dom';
import { PageLoader } from '@vastra/ui';
import Navbar from './Navbar';
import Footer from './Footer';
import PromoBanner from './PromoBanner';
import { useInAppHtmlLinkNavigation } from '../hooks/useInAppHtmlLinkNavigation';

const ContentLoader = () => (
  <div className="min-h-[50vh] flex items-center justify-center" role="status" aria-label="Loading page">
    <PageLoader variant="route" minHeight="40vh" />
  </div>
);

export interface CustomerLayoutProps {
  cartCount: number;
  wishlistCount: number;
  isAuthenticated: boolean;
  userName?: string;
  userRole?: string;
  onLogout: () => void;
  categories: string[];
  tags?: string[];
  multiLanguageEnabled?: boolean;
}

const CustomerLayout: React.FC<CustomerLayoutProps> = ({
  cartCount,
  wishlistCount,
  isAuthenticated,
  userName,
  userRole,
  onLogout,
  categories,
  tags = [],
  multiLanguageEnabled = false,
}) => {
  useInAppHtmlLinkNavigation();

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar
        cartCount={cartCount}
        wishlistCount={wishlistCount}
        isAuthenticated={isAuthenticated}
        userName={userName}
        userRole={userRole}
        onLogout={onLogout}
        categories={categories}
        tags={tags}
        multiLanguageEnabled={multiLanguageEnabled}
      />
      <PromoBanner />
      <main id="main-content" className="flex-1 min-w-0 overflow-x-hidden">
        <React.Suspense fallback={<ContentLoader />}>
          <div className="min-h-[50vh] animate-fade-in">
            <Outlet />
          </div>
        </React.Suspense>
      </main>
      <Footer categories={categories} />
    </div>
  );
};

export default CustomerLayout;
